<script>
import {
  ArrowUpIcon,
  MonitorIcon,
  FeatherIcon,
  EyeIcon,
  UserCheckIcon,
  UserIcon,
  SmartphoneIcon,
  HeartIcon,
  MailIcon,
  KeyIcon,
} from "vue-feather-icons";

import Vue from 'vue';
import { Carousel, Slide } from "vue-carousel";

import Navbar from "@/components/navbar";
import Switcher from "@/components/switcher";
import Footer from "@/components/footer";
import Pricing from "@/components/pricing2";
import Testimonial from "@/components/testimonial";

Vue.use(require('vue-moment'));

/**
 * Index application component
 */
export default {
  data() {
    return {
      data: {
        email: null,
        name: null,
      },
      mySubscription: {}

    };
  },
  components: {
    Navbar,
    Footer,
    MonitorIcon,
    FeatherIcon,
    EyeIcon,
    MailIcon,
    UserIcon,
    KeyIcon,
    UserCheckIcon,
    SmartphoneIcon,
    HeartIcon,
    ArrowUpIcon,
  },
  created(){
    this.$swal({
      text: 'Payment Failed!',
      icon: 'error',
    }).then((result) => {
        this.$router.push('/subscription')
    })
  },
  computed: {
    
  },
  methods: {
    isSubscriptionFound(){
      let activeSubscription = localStorage.getItem('subscription');
      if(activeSubscription != "undefined" && activeSubscription != 'null'){
        return true
      }else{
        return false
      }
    },
    update(e){
      e.preventDefault();

      if(!this.$refs.myForm.checkValidity()){
        this.$refs.myForm.reportValidity()
        return
      }

      window.axios.put('/api/user/update-details', this.data).then(res => {
        this.$swal({
          icon: 'success',
          text: 'Account updated',
          showConfirmButton: false,
          timer: 1500
        })
      })
    },
    
  }
};
</script>

<template>
  <div>
    <Navbar />
   
  </div>
</template>
